import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import useStore from './store';
import { Toaster } from 'sonner';
import './i18n-extended';
import './App.css';

import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import OnboardingPage from './pages/OnboardingPage';
import PlanWizard from './pages/PlanWizard';
import PlanDetailPage from './pages/PlanDetailPage';
import ShoppingListPage from './pages/ShoppingListPage';
import PricingPage from './pages/PricingPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import SettingsPage from './pages/SettingsPage';
import AdminPanel from './pages/AdminPanel';
import RecipesPage from './pages/RecipesPage';
import RecipeDetailPage from './pages/RecipeDetailPage';
import PointsPage from './pages/PointsPage';
import SlimUitEtenPage from './pages/SlimUitEtenPage';
import PlansPage from './pages/PlansPage';
import FavoritesPage from './pages/FavoritesPage';
import BabyModePage from './pages/BabyModePage';
import AppLayout from './components/AppLayout';
import ProtectedRoute from './components/ProtectedRoute';

function AppRouter() {
  const location = useLocation();
  const setUser = useStore((state) => state.setUser);

  useEffect(() => {
    fetch('/api/auth/me', { credentials: 'include' })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data && data.user_id) setUser(data); })
      .catch(() => {});
  }, []);

  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/auth-callback" element={<AuthCallback />} />
      <Route path="/pricing" element={<PricingPage />} />
      
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/plan/create" element={<PlanWizard />} />
        <Route path="/plan/:planId" element={<PlanDetailPage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/recipes" element={<RecipesPage />} />
        <Route path="/recipe/:recipeId" element={<RecipeDetailPage />} />
        <Route path="/favorites" element={<FavoritesPage />} />
        <Route path="/baby-mode" element={<BabyModePage />} />
        <Route path="/slim-uit-eten" element={<SlimUitEtenPage />} />
        <Route path="/points" element={<PointsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/shopping/:planId" element={<ShoppingListPage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
